// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XTvLAnBc8a949KzU9GtrhA\\=\\={position:relative}.XTvLAnBc8a949KzU9GtrhA\\=\\=>div:last-of-type{top:3.5rem !important;left:0 !important}", "",{"version":3,"sources":["webpack://./src/components/SearchLocationInput/SearchLocationInput.module.scss"],"names":[],"mappings":"AAAA,4BACE,iBAAA,CACA,6CACE,qBAAA,CACA,iBAAA","sourcesContent":[".container {\n  position: relative;\n  & > div:last-of-type {\n    top: 3.5rem !important;\n    left: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "XTvLAnBc8a949KzU9GtrhA=="
};
export default ___CSS_LOADER_EXPORT___;
